<section class="service-section shape-style-one section-gap">
    <div class="container-fluid">
        <!-- Section Title -->
        <div class="section-title text-center both-border mb-30">
            <!-- <span class="title-tag"></span> -->
            <h2 class="title">¿De qué se trata nuestro estándar?</h2>
            <h3 class="sub3">Sustentado en nuestros pilares:</h3>
        </div>
        <!-- Services Boxes -->
        <div class="row service-boxes justify-content-center">
            <div class="col-lg-3 col-md-6 col-sm-8 col-10 col-tiny-12" *ngFor="let item of service | slice:0:4">
                <div class="service-box">
                    <img [src]="item.shadowicon" [alt]="item.title" style="width: 100%;">
                    <div class="p-5">
                        <h3 class="text-center"><a routerLink="/service-details/{{item.id}}">{{item.title}}</a></h3>
                        <p><i *ngIf="item.shortdesc[0]" class="far fa-check iconOrange"></i> &nbsp;{{item.shortdesc[0]}}</p>
                        <p><i *ngIf="item.shortdesc[1]" class="far fa-check iconOrange"></i> &nbsp;{{item.shortdesc[1]}}</p>
                        <p><i *ngIf="item.shortdesc[2]" class="far fa-check iconOrange"></i> &nbsp;{{item.shortdesc[2]}}</p>
                    </div>
                    <!-- <a routerLink="/service-details/{{item.id}}" class="service-link">
                        <i class="fal fa-long-arrow-right"></i>
                    </a> -->
                </div>
            </div>
        </div>
        <div class="text-center justify-content-center">
            <h3 class="subInf3">25 módulos, repartidos en:</h3>
            <br/>
            <img src="assets/img/cadenSec3.png" alt="Cadena">
        </div>
    </div>
    <section id="Certificarse"></section>
</section>
